import { getLocale } from "@/data/regionInfo";
import { external3DScene } from '@/mixins/external3DScene';

export default {
  name: "sizeSelection",
  mixins: [external3DScene],
  computed: {
    configuration() {
      return this.$store.state.utils.configuration;
    },
    buyPanelConfiguration() {
      return this.$store.state.utils.configuration.vue_component_settings.buy_panel;
    },
    translations(){
      return this.$store.state.translations.data;
    },
    ugcSize() {
      return this.$store.state.buyPanel.ugcSize;
    },
    isUGCApplied() {
      return this.$store.state.buyPanel.isUGCApplied;
    },
    itemsToPurchase() {
      return this.$store.state.buyPanel.itemsToPurchase;
    },
    storedRecipes(){
      return this.$store.state.buyPanel.storedRecipes;
    },
    sizes() {
      return this.$store.state.utils.audienceSizes;
    },
    recipe_v2() {
      return this.$store.state.recipe.recipe_v2;
    },
    recipeId() {
      return this.$store.state.recipe.recipeId;
    },
    showSizeDropdown() {
      return this.sizes?.identifier?.length > 1;
    },
    /**
     * @function getComponentUg
     * This method find all components with ugc object.
     */
    getComponentsUgc() {
      return this.$store.getters["utils/getComponentsUgc"]({
        recipe: this.recipe_v2
      });
    },
    useEcomDataLayerFormat() {
      return this.$store.getters['utils/useEcomDataLayerFormat'];
    },
    maxQuantity() {
      return this.buyPanelConfiguration.max_quantity || 5
    },
    isSizeSelectorDisabled() {
      return this.$store.state.utils.configuration.ugc.disableSizeSelector;
    }
  },
  methods: {
    openGuideSizeModal() {
      if (!this.$props.showSizeGuide) return;
      this.$eventBus.$emit('hide-buy-panel');
      this.$eventBus.$emit('show-guide-size-modal');
    },
    /**
     * @function getTextSize
     * Return the Text Size from audience_sizes
     */
    getTextSize(identifierSize) {
      const ugcSizeIndex = this.sizes.identifier.indexOf(identifierSize);
      return ugcSizeIndex >= 0 ? this.sizes.values[ugcSizeIndex] : identifierSize;
    },
    /**
     * @function checkUGCasSwatch
     * This method evaluates if the recipe contains ugc as swatch
     * Returns true if any ugc component applied are ugc as swatch
     */
    checkUGCasSwatch() {
      if (!this.$ugc) return false;
      return this.$ugc.hasUGCFromSwatch();
    },
    /**
     * @function setUgcSizeSelected
     * This method change the ugc size selected.
     * If only exist one item to purchase, after reposition flow
     * the ugc needs to be changed.
     * Besides, the recipeIds should be empty.
     */
    setUgcSizeSelected() {
      if (this.itemsToPurchase.length === 1 && !this.isSizeSelectorDisabled) {
        this.$store.commit("buyPanel/SET_UGC_SIZE", this.itemsToPurchase[0].size);
        this.$store.commit("buyPanel/RESET_STORED_RECIPES");
      }
    },
    onChangeQuantity(value, index) {
      this.$store.commit("buyPanel/SAVE_ITEM_QUANTITY", {index, quantity: Number(value)});

      if (this.useEcomDataLayerFormat) {
        this.$customizerDataLayer.logAnalyticsEvent({
          type: this.$customizerDataLayer.types.customizerBuyPanel,
          subtype: 'Select Quantity',
          eventLabel: value
        });
      }
    },
    /**
     * @function onChangeSize
     * This method verify selected size.
     * If only exist one select we won't validate anything.
     * If there are more than one select and the recipe has ugc object
     * show the repositionWarningModal.
     */
    onChangeSize(value, index) {
      const UGCasSwatch = this.checkUGCasSwatch();
      const hasPatternOrCustomCheckerboard = this.$recipe.checkUGCByType({ includePatternMaker: true, includeCustomCheckerboard: true });
      this.$store.commit("buyPanel/SAVE_ITEM_SIZE", { index, size: value });

      if (this.useEcomDataLayerFormat) {
        this.$customizerDataLayer.logAnalyticsEvent({
          type: this.$customizerDataLayer.types.customizerBuyPanel,
          subtype: 'Select Size',
          eventLabel: value
        });
      }
      if(this.isSizeSelectorDisabled &&
        this.$store.getters["ugc/getComponentsWithUGCApplied"].length > 0)
      {
        this.updateSizeInUGCObject({size: value, index});
      } else if (
        (!UGCasSwatch && !this.isUGCApplied && !hasPatternOrCustomCheckerboard) ||
        (index > 0 && (this.isUGCApplied && this.ugcSize === value || this.$store.getters['utils/isApparelEnabled'] ))
      ) {
        this.$store.commit("buyPanel/STORE_A_RECIPE", this.recipeId);
        this.$eventBus.$emit("enable-add-to-cart-button", true);
      } else if (index > 0 && (this.isUGCApplied && this.ugcSize !== value && !this.$store.getters['utils/isApparelEnabled'])) {
        this.$eventBus.$emit("hide-buy-panel");

        const recipes = this.$store.getters["ugc/storageController/GET_STORAGE_RECIPES"];
        let deletePreviousRecipe = false;
        if (recipes.length == this.itemsToPurchase.length) {
          deletePreviousRecipe = true;
        }
        if (!this.$store.getters['utils/isApparelEnabled']) {
          this.$modal.show(this.$store.state.utils.configuration.enableNewUgcModal ? "NewRepositionWarningModal" : "RepositionWarningModal", {
            selectedSize: this.getTextSize(value),
            ugcSize: this.getTextSize(this.ugcSize),
            sizeIdentifierValue: value,
            deletePreviousRecipe: deletePreviousRecipe,
            storeMultipleUGCsizes: true
          });
       }
      } else if (UGCasSwatch || hasPatternOrCustomCheckerboard) {
        this.updateSizeInUGCObject({size: value, index});
      }
    },

    updateSizeInUGCObject({size, index}) {
      this.$eventBus.$emit("enable-add-to-cart-button", false);
        const ugcComponents = this.getComponentsUgc;
        ugcComponents.forEach(component => {
          const data = this.recipe_v2.components[component];
            data.ugc.size = size;
            this.$store.commit("recipe/UPDATE_COMPONENT", { componentName: component, data });
        });

        this.$store
          .dispatch("recipe/SAVE_RECIPE", {
            recipe: this.recipe_v2,
            requestParams: { locale: getLocale() },
            type: this.$props.type
          })
          .then(async ({ recipeId }) => {
            this.$store.commit("buyPanel/STORE_A_RECIPE", { index, recipeId });
            if(this.configuration.enableSnapshotService) await this.initExternal3Dscene({domEl: "snapshot-image-scene", snapshotSize: "lg-pdp-white", snapshotView: "left_pdp", showSnapShot: false});
            else {
              await this.$store.dispatch("ugc/tempData/GET_PRODUCT_IMAGES_BY_RECIPE_ID", {
                recipe_id: this.recipe_v2.recipe_id,
                locale: getLocale(),
                size: "lg-pdp-white",
                view: "left_pdp"
            })}
            this.$eventBus.$emit("enable-add-to-cart-button", true);
          })
          .catch(err => {
            console.error("Error getting product recipe id:", err);
            this.$eventBus.$emit("enable-add-to-cart-button", true);
          });
    },
    autoSelectUniqueSizes() {
      // Exists more than 1 possible size, do nothing
      if (this.showSizeDropdown || !this.sizes) return;
      this.itemsToPurchase.forEach((item, index) => {
        // If size has not been selected yet
        if (!item.size) {
          this.onChangeSize(this.sizes.identifier[0], index);
        }
      });
    }
  },
  created(){
    this.$eventBus.$on("set-ugc-size-selected", this.setUgcSizeSelected);
    this.$eventBus.$on('recipe-saved', this.autoSelectUniqueSizes);
    this.$eventBus.$on('get-osfa-size', this.autoSelectUniqueSizes);
  },
  beforeDestroy(){
    this.$eventBus.$off("set-ugc-size-selected", this.setUgcSizeSelected);
    this.$eventBus.$off('recipe-saved', this.autoSelectUniqueSizes);
    this.$eventBus.$off('get-osfa-size', this.autoSelectUniqueSizes);
  }
};
